import { PropsWithChildren, createContext, useEffect, useState } from "react";
import { Currency } from "src/models/Currency";
import { appSettings } from "src/models/appSettings";

type ReferenceContextType = {
  currencyList: Currency[];
  setCurrencyList: React.Dispatch<React.SetStateAction<Currency[]>>;
  appSettings: appSettings;
};

const initialAppSettings: appSettings = {
  dateRangeMonthsLimit_View: 3,
  dateRangeMonthsLimit_Download: 14,
};

const ReferenceContext = createContext({} as ReferenceContextType);

export const ReferenceProvider = ({ children }: PropsWithChildren) => {
  const [currencyList, setCurrencyList] = useState<Currency[]>([]);
  const [appSettings, setAppSettings] =
    useState<appSettings>(initialAppSettings);

  useEffect(() => {
    const loadAppSettings = async () => {
      const response = await fetch("/appSettings.json");
      if (!response.ok) {
        setAppSettings(initialAppSettings);
      } else {
        const data = await response.json();
        setAppSettings(data);
      }
    };
    loadAppSettings();
  }, []);

  return (
    <ReferenceContext.Provider
      value={{
        currencyList,
        setCurrencyList,
        appSettings
      }}
    >
      {children}
    </ReferenceContext.Provider>
  );
};

export default ReferenceContext;
